import { SubscriptionResponse } from "@biggeo/bg-server-lib/studio";
import { Box, Stack } from "@biggeo/bg-ui/lab";
import * as A from "fp-ts/Array";
import { pipe } from "fp-ts/lib/function";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import { RefObject } from "react";
import { MapContextDataset } from "../context/types";
import MapLegendInfo from "./MapLegendInfo";

type MapInfoElementsProps = {
    readonly responses: Partial<Record<string, SubscriptionResponse | null>>;
    readonly map: React.MutableRefObject<mapboxgl.Map | null>;
    readonly isMapLoaded: boolean;
    readonly datasets: MapContextDataset[];
    readonly parentRef: RefObject<HTMLDivElement>;
};

const MapInfoElements = ({
    responses,
    map,
    isMapLoaded,
    datasets,
    parentRef,
}: MapInfoElementsProps) => {
    const datasetLegends = pipe(
        datasets,
        A.filter((f) => isEqual(f.isLegendOpen, true))
    );
    return (
        <Stack
            gap={2}
            justifyContent="flex-end"
            sx={{
                position: "absolute",
                left: 4,
                top: 4,
                display: "none",
                width: "32%",
                maxWidth: 80,
                breakpoints: {
                    md: {
                        display: "flex",
                    },
                },
            }}
        >
            <Box
                id="geocoder"
                sx={{
                    "& >.mapboxgl-ctrl-geocoder.mapboxgl-ctrl": {
                        minWidth: "100%",
                    },
                }}
            />
            {!isEmpty(datasetLegends) && parentRef.current && (
                <MapLegendInfo
                    responses={responses}
                    map={map}
                    datasets={datasetLegends}
                    isMapLoaded={isMapLoaded}
                    parentHeight={parentRef.current.clientHeight}
                />
            )}
        </Stack>
    );
};

export default MapInfoElements;
